import { IFormSchema } from '@publishing-engine/domain/models/form-schema';
import { ComponentName, ExtractType } from '@publishing-engine/domain/types';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';

type ISubmissionForms = {
  authorSubmission?: IFormSchema;
  authorRevision?: IFormSchema;
  editorialLicensing?: IFormSchema;
};

/**
 * Wrapper around submission formSchemas (at the moment authorSubmission and authorRevision)
 * to provide convenience access around shared and unique formFieldDefinitions.
 */
export class SubmissionFormFields {
  private forms: ISubmissionForms;

  constructor(
    authorSubmission?: IFormSchema,
    authorRevision?: IFormSchema,
    editorialLicensing?: IFormSchema
  ) {
    this.forms = {};

    if (authorSubmission) {
      this.forms.authorSubmission = authorSubmission;
    }
    if (authorRevision) {
      this.forms.authorRevision = authorRevision;
    }
    if (editorialLicensing) {
      this.forms.editorialLicensing = editorialLicensing;
    }
  }

  hasField<CN extends ComponentName>(componentName: CN) {
    return Object.values(this.forms).reduce((found, form) => {
      if (found) {
        return true;
      }
      return form.formFields?.some(cfg => cfg.name === componentName) ?? false;
    }, false);
  }

  getFieldConfig<CN extends ComponentName>(componentName: CN) {
    // Changing the order of the form field lookup to prioritize authorRevision over authorSubmission
    const fieldConfig =
      this.forms.authorRevision?.formFields?.find(
        cfg => cfg.name === componentName
      ) ??
      this.forms.authorSubmission?.formFields?.find(
        cfg => cfg.name === componentName
      ) ??
      null;

    return fieldConfig as ExtractType<FormFieldDefinition, CN> | null;
  }
}
